import GoogleAdsObjectivePicker from '../GoogleAdsObjectivePicker';

export default GoogleAdsObjectivePicker;
